import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import Retry from "views/YuuTransaction/Retry";
import ViewYuuTransaction from "views/YuuTransaction/ViewYuuTransaction";
import { token } from "functions/Helper";
import EnqueuedList from "views/YuuTransaction/EnqueuedList";
import FailedList from "views/YuuTransaction/FailedList";
import InEligibleList from "views/YuuTransaction/InEligibleList";
import ProcessedList from "views/YuuTransaction/ProcessedList";
import CreateYuuTransaction from "views/YuuTransaction/Create";

const yuuTransaction = () => {
  let views = [];

  if (
    token["yuu.transactions.read"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views = views.concat([
      {
        path: "/YuuTransaction/Enqueued",
        name: "Enqueued",
        mini: "EN",
        component: EnqueuedList,
        layout: "/admin"
      },
      {
        path: "/YuuTransaction/Processed",
        name: "Processed",
        mini: "PR",
        component: ProcessedList,
        layout: "/admin"
      },
      {
        path: "/YuuTransaction/InEligible",
        name: "InEligible",
        mini: "IE",
        component: InEligibleList,
        layout: "/admin"
      },
      {
        path: "/YuuTransaction/Failed",
        name: "Failed",
        mini: "FA",
        component: FailedList,
        layout: "/admin"
      }
    ]);
  }

  if (views.length > 0)
    return [
      {
        collapse: true,
        name: "Yuu Transaction",
        icon: MonetizationOnIcon,
        state: "YuuTransaction",
        views: views
      }
    ];
  return [];
};

const yuuTransactionHidden = () => {
  let views = [];

  if (
    token["yuu.transactions.read"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views.push({
      path: "/YuuTransaction/Detail",
      name: "View Yuu Transaction",
      component: ViewYuuTransaction,
      layout: "/admin",
      params: [
        {
          name: "id"
        }
      ]
    });
  }

  if (
    token["yuu.transactions.write"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views = views.concat([
      {
        path: "/YuuTransaction/Retry",
        name: "Retry Yuu Transaction",
        component: Retry,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      },
      {
        path: "/YuuTransaction/Create",
        name: "Create Yuu Transaction",
        component: CreateYuuTransaction,
        layout: "/admin"
      }
    ]);
  }

  return [
    {
      collapse: true,
      name: "Yuu Transaction Hidden",
      state: "YuuTransactionHidden",
      hideInSidebar: true,
      views: views
    }
  ];
};

export { yuuTransaction, yuuTransactionHidden };
